import React, { useReducer, useEffect } from 'react'
import PursuitsPageService from './Service'
import pursuitsPageReducer from './store/Reducer'
import { get, debounce } from 'lodash'
import { setPursuits } from './store/Actions'
import { pursuitsPageInitialState } from './store/State'
import { IPartialPursuit, IQuestions, IResponsesValue, IResponseUpdateRequestPayload } from 'types'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'
import { useServiceState, useNotification } from 'helpers'
import { IProps } from './Interface'

const pursuitsPageContext = {
  state: {
    ...pursuitsPageInitialState,
    questions: {}
  },
  handlers: {
    handleOnInit: () => {},
    handleUpdatePursuit: () => new Promise<void>(() => {}),
    handleChangePursuit: (_payload: IPartialPursuit) => {},
    handleSetEdit: (_payload: { [key: number]: boolean }) => {},
    handleDeletePursuit: (_index: number) => {}
  }
}

export type PursuitsPageContext = typeof pursuitsPageContext & {
  state: { questions: IQuestions }
}

export const PursuitsPageContextProvider = React.createContext<PursuitsPageContext>(pursuitsPageContext)

const Provider: React.FC<IProps> = ({ children, responses }) => {
  const userResponsesManagerState = useServiceState(UserResponsesManagerService, false)
  const { emitError } = useNotification()
  const newResponses = responses || userResponsesManagerState.userResponses?.responses || ({} as IResponsesValue)
  const questions: IQuestions = userResponsesManagerState.userResponses?.questions || ({} as IQuestions)

  const updateResponse = async (payload: IResponseUpdateRequestPayload) => {
    if (responses) {
      return
    }
    const error = await UserResponsesManagerService.updateResponse(payload)

    if (error) {
      emitError(error)
    }
  }

  const passions = get(newResponses, 'passions', [])
  const [state, dispatch] = useReducer(pursuitsPageReducer, pursuitsPageInitialState)

  const handleOnInit = () => {
    state.passions
      ?.map((passion, index) => {
        if (passion.detail && passion.title) {
          return () => handlers.handleSetEdit({ [index]: false })
        }
        return debounce(() => {
          handlers.handleSetEdit({ [index]: true })
        })
      })
      ?.reverse()
      .map(setEdit => setEdit())
  }

  const handlers = {
    handleOnInit,
    handleUpdatePursuit: PursuitsPageService.handleUpdatePursuit(state, updateResponse),
    handleChangePursuit: PursuitsPageService.handleChangePursuit(dispatch),
    handleSetEdit: PursuitsPageService.handleSetEdit(dispatch),
    handleDeletePursuit: PursuitsPageService.deletePursuit(dispatch)
  }

  useEffect(() => {
    dispatch(setPursuits(state.passions.map((_, i) => passions[i] ?? { title: '', detail: '' })))
  }, [passions])

  const contextValue = {
    state: {
      ...state,
      questions
    },
    handlers
  }

  return <PursuitsPageContextProvider.Provider value={contextValue}>{children}</PursuitsPageContextProvider.Provider>
}

export default Provider
